// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.spaceBackground[data-v-721df7b1] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  background-size: cover;\n  animation: zoom-721df7b1 20s ease-in-out infinite alternate;\n}\n@keyframes zoom-721df7b1 {\nfrom {\n    transform: scale(1);\n}\nto {\n    transform: scale(1.5);\n}\n}\n", ""]);
// Exports
module.exports = exports;
